import type { ReactNode } from "react";

/**
 * The workspace shell (top bar + nav + persistent chat + slide-over inspector)
 * now lives in `routes/$workspace.tsx` so it wraps every child route uniformly.
 *
 * This component used to render the shell; we kept the name but turned it into
 * a passthrough so existing routes that still import it don't double-wrap the
 * layout. Once those routes are cleaned up this file can be deleted.
 */
export function WorkspaceShell({
  children,
}: {
  children: ReactNode;
  title?: ReactNode;
}) {
  return <>{children}</>;
}
